const addQuotesToString = (query) => {
  if (query.startsWith('"') && query.endsWith('"')) {
    return query;
  } else {
    return `"${query}"`;
  }
};

export default addQuotesToString;
